import {withTheme} from '@rneui/themed';

import DateOfBirthInput from '../ui-controls/DateOfBirthInput';

type Props = React.ComponentProps<typeof DateOfBirthInput>;

export default withTheme<Props>(DateOfBirthInput, 'DateOfBirthInput');

declare module '@rneui/themed' {
  export interface ComponentTheme {
    DateOfBirthInput: Partial<Props>;
  }
}
